import {
  useCallback,
} from 'react'
import {
  loadStripe,
} from '@stripe/stripe-js'
import {
  EmbeddedCheckoutProvider, EmbeddedCheckout,
} from '@stripe/react-stripe-js'
import {
  X,
} from 'lucide-react'
import {
  STRIPE_PUBLISHABLE_KEY,
} from '../services/api'

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY)

interface CheckoutModalProps {
  clientSecret: string
  onClose: () => void
}

export function CheckoutModal({ clientSecret, onClose }: CheckoutModalProps): JSX.Element {
  const fetchClientSecret = useCallback(() => Promise.resolve(clientSecret), [clientSecret])

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />
      <div className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto bg-white rounded-2xl shadow-xl m-4">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 p-1 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="p-1">
          <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{ fetchClientSecret }}
          >
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </div>
      </div>
    </div>
  )
}
